// Franchise tier data + comparison matrix
// Used by /franchise, /franchise/compare, /franchise/checkout, and admin

export const FRANCHISE_TIERS = {
  starter: {
    id: "starter",
    name: "WealthFirst Starter",
    tagline: "Begin the practice.",
    setup: 2400,
    monthly: 291,
    setupDisplay: "$2,400",
    monthlyDisplay: "$291 / month",
    headline: "Launch your own funding consultancy.",
    description: "Everything you need to open a branded business-funding practice — quietly, on the right side of the desk.",
    clientLimit: 40,
    clientLimitDisplay: "Up to 40 active clients",
    cta: "Start as WealthFirst Starter",
    features: [
      "Full AI Funding Report engine for your clients",
      "WealthFirst PRO Membership (white-labeled)",
      "AutoPilot credit-building automation",
      "Custom domain (yourbrand.com)",
      "Basic white-label branding",
      "Unlimited profile-based lender database",
      "Up to 40 active clients",
      "Email support · admin dashboard · training library",
    ],
  },
  grow_rich: {
    id: "grow_rich",
    name: "WealthFirst Grow-Rich",
    tagline: "Scale with conviction.",
    setup: 9999,
    monthly: 991,
    setupDisplay: "$9,999",
    monthlyDisplay: "$991 / month",
    featured: true,
    badge: "Most Popular",
    headline: "A franchise of probabilities — built to compound.",
    description:
      "A systematic process of identifying, assessing, and controlling threats to investment capital — superior risk management to ensure that no single event or series of events can result in catastrophic scenarios and market downturns that prevent further participation in a extreme volatile market. By treating a franchise business of probabilities, risk management allows consistent execution even during periods of extreme uncertainty.",
    clientLimit: 400,
    clientLimitDisplay: "Up to 400 active clients",
    cta: "Become a Grow-Rich Partner",
    features: [
      "Everything in WealthFirst Starter",
      "Full white-label branding (logo, palette, typography, email)",
      "Risk-management framework & playbooks",
      "Capital-preservation scenario modeling",
      "Priority partner phone & email support",
      "Quarterly strategy salons with the WFI editorial desk",
      "Up to 400 active clients",
      "Annotated trust + entity templates",
    ],
  },
  enterprise: {
    id: "enterprise",
    name: "WealthFirst Enterprise",
    tagline: "The whole institution.",
    setup: 24000,
    monthly: 1991,
    setupDisplay: "$24,000",
    monthlyDisplay: "$1,991 / month",
    headline: "No ceiling. Unlimited capacity.",
    description: "Everything in Grow-Rich, with no client cap. For partners scaling beyond a single market.",
    clientLimit: null,
    clientLimitDisplay: "Unlimited clients",
    cta: "Apply for Enterprise",
    features: [
      "Everything in WealthFirst Grow-Rich",
      "Unlimited active clients",
      "Multi-region / multi-entity routing",
      "Dedicated partner success manager",
      "Custom AI report templates (your firm's house style)",
      "Co-branded private salons & member dinners",
      "White-glove migration assistance",
    ],
  },
};

// Payment options for setup-fee splitting (illustrated on Grow-Rich; adaptable to all tiers)
export const PAYMENT_OPTIONS = {
  upfront: {
    id: "upfront",
    label: "Pay upfront",
    setupAmount: 9000,
    setupDisplay: "$9,000",
    note: "One-time setup discount — save $999 vs. list",
    schedule: "Today: $9,000 setup + $991 first month = $9,991",
  },
  installments: {
    id: "installments",
    label: "Flexible 4-payment plan",
    setupAmount: 2250,
    setupDisplay: "$2,250 × 4 months",
    note: "Spread the setup fee across four monthly installments",
    schedule: "Today: $2,250 + $991 = $3,241 · then $2,250 + $991 for three more months · then $991/mo recurring",
  },
};

// Full comparison matrix: 'basic' = Starter capability, 'full' = Grow-Rich addition, 'unlimited' = Enterprise addition
export const FRANCHISE_COMPARISON = [
  // Basic — Starter
  { group: "basic", feature: "AI Funding Reports for your clients", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "WealthFirst PRO Membership (white-labeled)", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "AutoPilot credit-building automation", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "Custom domain (yourbrand.com)", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "Basic white-label branding", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "Unlimited profile-based lender database", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "Email support · admin dashboard · training library", starter: true, grow_rich: true, enterprise: true },
  { group: "basic", feature: "Active client limit", starter: "40", grow_rich: "400", enterprise: "Unlimited" },
  // Full — Grow-Rich
  { group: "full", feature: "Full white-label branding (logo, palette, typography, email)", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Risk-management framework & playbooks", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Capital-preservation scenario modeling", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Priority partner phone & email support", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Quarterly strategy salons with WFI editorial desk", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Annotated trust & entity templates", starter: false, grow_rich: true, enterprise: true },
  { group: "full", feature: "Flexible 4-payment setup plan available", starter: false, grow_rich: true, enterprise: true },
  // Unlimited — Enterprise
  { group: "unlimited", feature: "No active-client ceiling", starter: false, grow_rich: false, enterprise: true },
  { group: "unlimited", feature: "Multi-region / multi-entity routing", starter: false, grow_rich: false, enterprise: true },
  { group: "unlimited", feature: "Dedicated partner success manager", starter: false, grow_rich: false, enterprise: true },
  { group: "unlimited", feature: "Custom AI report templates (house style)", starter: false, grow_rich: false, enterprise: true },
  { group: "unlimited", feature: "Co-branded private salons & member dinners", starter: false, grow_rich: false, enterprise: true },
  { group: "unlimited", feature: "White-glove migration assistance", starter: false, grow_rich: false, enterprise: true },
];

export const GROUP_LABEL = {
  basic: "Basic Package — All Tiers",
  full: "Full Package — Grow-Rich & Enterprise",
  unlimited: "Unlimited Package — Enterprise only",
};
